import { useContext, useEffect, useState } from 'react';

import {
  ColSize,
  ContentSection,
  RowSize,
  SelectForm,
} from '../../../../../../../../../../../shared/components';

import { StepTwoFormContext } from '../../../../contexts/StepTwoForm/StepTwoFormContext';

import { ValidateForm } from '../../../../../../../../../../../shared/utils';
import { MasterContext } from '../../../../../../../../../../../shared/contexts';
import { QuotationInfoContext } from '../../../../../../../shared';
import { getExplanatoryTexts } from '../../../../../../../utils';
import { Typography } from 'antd';
import { COLORS } from '../../../../../../../../../../../config/themes/colors';

interface PlanSectionProps {
  id: number;
  duplicateId?: number;
}

export const PlansSection = ({ id, duplicateId }: PlanSectionProps) => {
  const validateForm = new ValidateForm();

  const { stepTwoForm, planOptionsBySelectedPlan } =
    useContext(StepTwoFormContext);

  const { globalPublicConfigs } = useContext(MasterContext);
  const { quotationInfo } = useContext(QuotationInfoContext);
  const [explanatoryText, setExplanatoryText] = useState<string>("");    
  const handleExplanatoryText = () => {
    const text = getExplanatoryTexts(
        Number(quotationInfo?.branch),
        Number(quotationInfo?.article), 
        Number(stepTwoForm?.getFieldValue(`plan-tab-${id}`)),
      globalPublicConfigs?.QUOTATION_EXPLANATORY_TEXTS
    );
    setExplanatoryText(text);
  };

  useEffect(() => {
    handleExplanatoryText();
    if (duplicateId) {
      const duplicatePlan = stepTwoForm?.getFieldValue(
        `plan-tab-${duplicateId}`
      );
      stepTwoForm?.setFieldValue(`plan-tab-${id}`, duplicatePlan);
      
    }
  }, [duplicateId, stepTwoForm, id]);

  return (
    <ContentSection level='h3' title='Planes'>
      <RowSize>
        <ColSize size={25}>
          <SelectForm
            formProps={{
              label: 'Lista de Planes:',
              name: `plan-tab-${id}`,
              rules: validateForm.generateRules({
                label: 'plan',
                rules: ['required'],
              }),
            }}
            selectProps={{
              placeholder: 'Seleccionar',
              options: planOptionsBySelectedPlan,
              onChange: handleExplanatoryText,
            }}
          />
        </ColSize>
      </RowSize>
      {!!explanatoryText && 
        <Typography.Text strong style={{ fontSize: 16, color: COLORS.neutrals[70] }} >
          {explanatoryText}
        </Typography.Text>
      }        
    </ContentSection>
  );
};
